const medicalTeamStatus = {
    OPEN: 0,
    CLOSE:1
}

export default medicalTeamStatus;